import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
	changeLayout,
	changeTopbarTheme,
	changeLayoutWidth,
} from "../../store/actions";

// Other Layout related Component
import Rightbar from "../CommonForBoth/Rightbar";
import Footer from "components/Website/Layouts/Footer";
import Navbar from "components/Website/Layouts/Navbar";

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMenuOpened: false,
		};
	}

	componentDidMount() {
		if (this.props.isPreloader === true) {
			document.getElementById("preloader").style.display = "block";
			document.getElementById("status").style.display = "block";

			setTimeout(function () {
				document.getElementById("preloader").style.display = "none";
				document.getElementById("status").style.display = "none";
			}, 2500);
		} else {
			document.getElementById("preloader").style.display = "none";
			document.getElementById("status").style.display = "none";
		}

		// Scrollto 0,0
		window.scrollTo(0, 0);

		const title = this.props.location.pathname;
		let currentage = title.charAt(1).toUpperCase() + title.slice(2);

		document.title = currentage + "";

		this.props.changeLayout("horizontal");
		if (this.props.topbarTheme) {
			this.props.changeTopbarTheme(this.props.topbarTheme);
		}
		if (this.props.layoutWidth) {
			this.props.changeLayoutWidth(this.props.layoutWidth);
		}
	}

	/**
	 * Opens the menu - mobile
	 */
	openMenu = () => {
		this.setState({ isMenuOpened: !this.state.isMenuOpened });
	};

	render() {
		return (
			<React.Fragment>
				<div id="preloader">
					<div id="status">
						<div className="spinner-chase">
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
						</div>
					</div>
				</div>

				<div id="layout-wrapper">
					<Navbar />
					<div className="main-content">{this.props.children}</div>
					<Footer />
				</div>

				{this.props.showRightSidebar ? <Rightbar /> : null}
			</React.Fragment>
		);
	}
}

Layout.propTypes = {
	changeLayout: PropTypes.func,
	changeLayoutWidth: PropTypes.func,
	changeTopbarTheme: PropTypes.func,
	children: PropTypes.object,
	isPreloader: PropTypes.any,
	layoutWidth: PropTypes.any,
	location: PropTypes.object,
	showRightSidebar: PropTypes.any,
	routePrefix: PropTypes.string,
	topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => {
	return {
		...state.Layout,
	};
};
export default connect(mapStatetoProps, {
	changeTopbarTheme,
	changeLayout,
	changeLayoutWidth,
})(withRouter(Layout));
